"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExportType;
(function (ExportType) {
    ExportType[ExportType["DONT_DOWNLOAD"] = -1] = "DONT_DOWNLOAD";
    ExportType[ExportType["PDF"] = 1] = "PDF";
    ExportType[ExportType["WORD"] = 2] = "WORD";
    ExportType[ExportType["EXCEL"] = 3] = "EXCEL";
})(ExportType = exports.ExportType || (exports.ExportType = {}));
var ExportOrientation;
(function (ExportOrientation) {
    ExportOrientation[ExportOrientation["PORTRAIT"] = 0] = "PORTRAIT";
    ExportOrientation[ExportOrientation["LANDSCAPE"] = 1] = "LANDSCAPE";
})(ExportOrientation = exports.ExportOrientation || (exports.ExportOrientation = {}));
//# sourceMappingURL=export-widget-interfaces.js.map